export interface TimerInfo {
  status: TimerStatusType;
  seconds: string;
  minutes: string;
  hours: string;
  days: string;
}

export enum TimerStatusType {
  STARTING = 'starting',
  ACTIVE = 'active',
  ENDED = 'ended',
}

export enum PromoBackgroundModifiers {
  Blue = 'blue',
  Grey = 'grey',
  Red = 'red',
  LightBlue = 'lightBlue',
  Brown = 'brown',
  Bonus = 'bonus',
}

export enum CoBrandProms {
  DDW = 'DDW',
  Slotmania = 'IDNLCSM',
  BronzeBlackJack = 'BBJT',
  SilverBlackJack = 'SBJT',
  GoldBlackJack = 'GBJT',
  PrivateBlackJack = 'PRBJT',
  NONDDW = 'NONDDW',
}

export enum SCREEN_TYPES {
  DESKTOP = 'desktop',
  PORTRAIT = 'portriat',
  LANDSCAPE = 'landscape',
}

export interface Interval {
  min: number;
  max: number;
}

export enum PromoNotificationType {
  BonusCardLimitReached = 'PROMO_LIMIT_REACHED',
  BonusCardPromotionCancelled = 'BONUS_CARD_PROMOTION_CANCELLED',
}
